import formatBytes from "tools/formats/formatBytes";
import React, {FC} from "react";
import DataRow from "view/components/DataRow";
import {UnpackedAttachmentFile} from "ts/api/attachmentFile";
import {convertFileUrl} from "tools/convertFileUrl";
import useStyles from "./styles";

type Props = {
  attachment: UnpackedAttachmentFile;
  renderActionPanel: () => JSX.Element;
  icon: any;
  onClick?: () => void | Promise<void> | null;
};

const AttachmentItem: FC<Props> = ({
  attachment,
  renderActionPanel,
  icon,
  onClick = () => {
    // Open a blank tab synchronously (preserves the user-gesture so
    // popup-blockers stay quiet), then redirect once `convertFileUrl`
    // appends the Firebase `?token=` for auth-gated AWS files.
    const popup = window.open("", "_blank");
    convertFileUrl(attachment.url, attachment?.provider)
      .then((url) => {
        if (popup) popup.location.href = url;
      })
      .catch(() => {
        if (popup) popup.location.href = attachment.url;
      });
  },
}) => {
  const classes = useStyles();

  const {id, size, extension, title} = attachment;

  return (
    <DataRow
      key={id}
      value={title}
      label={`${extension}, ${formatBytes(size)}`}
      icon={icon}
      actionPanel={renderActionPanel()}
      onClickRoot={onClick}
      classes={{
        label: classes.fileExtension,
        value: classes.fileName,
        root: classes.fileRoot,
        actionPanel: classes.fileActions,
      }}
      last
    />
  );
};

export default AttachmentItem;
